import {
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import LandingImg from "../../../assets/LandingImg.png";

const Landing = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ backgroundColor: "#EEF6FF" }}>
        {isMobile ? (
          <Container sx={{ display: "flex", justifyContent: "center" }}>
            <img
              src={LandingImg}
              alt=""
              style={{
                marginTop: "3.75rem",
                marginBottom: "3.75rem",
                width: "20.563125rem",
                objectFit: "contain",
              }}
            />
          </Container>
        ) : (
          <Container sx={{ display: "flex", justifyContent: "center" }}>
            <img
              src={LandingImg}
              alt=""
              style={{ maxWidth: "90%", marginTop: "4.5rem", marginBottom: "4.4375rem" }}
            />
          </Container>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default Landing;
